import { render, staticRenderFns } from "./CardStyle4.vue?vue&type=template&id=52e29383"
import script from "./CardStyle4.vue?vue&type=script&lang=js"
export * from "./CardStyle4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports